import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { SegmentoSegurosComponent } from './segmento-seguros.component';
import { CabecalhoDireitaModule } from '../../components/cabecalho/cabecalho-direita/cabecalho-direita.module';
import { SolucoesModule } from '../../components/solucoes/solucoes.module';
import { ExemplosModule } from '../../components/exemplos/exemplos.module';

@NgModule({
  declarations: [
    SegmentoSegurosComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    CabecalhoDireitaModule,
    SolucoesModule,
    ExemplosModule
  ],
  exports: [
    SegmentoSegurosComponent
  ]
})

export class SegmentoSegurosModule { }
